// extracted by mini-css-extract-plugin
export default {"Landing":"Landing_Landing__l0yBB","titulo":"Landing_titulo__h8RhB","containerBtn":"Landing_containerBtn__X19Pz","button":"Landing_button__TQThL"};